module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/does-vux-support-weex-13.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/does-vux-support-weex.md
// module id = 591
// module chunks = 443